import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { isNavItemActive } from '../navigation/build-navigation';
import { NavItem } from '../navigation/nav-item.model';

/** A list of navigation entries; groups open on click and stay open while one of their pages is shown. */
@Component({
    selector: 'app-nav-list',
    templateUrl: './nav-list.component.html',
    styleUrls: ['./nav-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NavListComponent {
    @Input({ required: true }) items: NavItem[] = [];
    /** The current router URL, which decides the highlighted entry. */
    @Input({ required: true }) currentUrl = '';
    /** Emits once an entry has been followed, so a mobile drawer can close. */
    @Output() readonly selected = new EventEmitter<NavItem>();

    /** Groups the user opened or closed by hand; the others follow the current page. */
    private readonly toggledGroups = new Map<string, boolean>();

    isActive(item: NavItem): boolean {
        return isNavItemActive(item, this.currentUrl);
    }

    isExpanded(group: NavItem): boolean {
        return !group.disabled && (this.toggledGroups.get(group.id) ?? this.isActive(group));
    }

    toggle(group: NavItem): void {
        if (!group.disabled) {
            this.toggledGroups.set(group.id, !this.isExpanded(group));
        }
    }

    follow(item: NavItem): void {
        item.action?.();
        this.selected.emit(item);
    }
}
